import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
export const IconInfoRaw = ({ icon, text, html, className }) => {
    return (_jsxs("div", { className: `icon-info-raw${className ? ` ${className}` : ''}`, children: [_jsx("span", { className: "icon", children: icon }), _jsx("span", { className: "text", dangerouslySetInnerHTML: html ? html : undefined, children: !!text && !html ? text : null })] }));
};
export default IconInfoRaw;
